module.exports = __webpack_public_path__ + "img/czcloud_img.05692898.png";